
const allProjects = [
  {
    "title" :"onNotebook",
    "desc" : "An online note saving web application is a platform that enables users to create, store, and manage notes online. The app provides a simple, interactive, and user-friendly interface. Users can access their notes from any device connected to the internet, making it easy to keep track of important information on the go. With an online note saving web application, users can be sure that their notes are safe and secure, and that they can access them whenever they need them.",
    "techStack" : ["React","Node","MongoDb","Express","Bootstrap"],
    "link" : "https://on-notebook.netlify.app"
  },
  {
    "title" :"Babble",
    "desc" : "The Online Chat Web Application is a real-time chat platform built using the MERN stack. It allows users to authenticate and authorize themselves before engaging in chat conversations. Users can add and remove persons from thier chat list and they can send emojis also.",
    "techStack" : ["React","Node","MongoDb","Express","SocketIO"],
    "link" : "https://chat-bird.netlify.app"
  },
  {
    "title" :"Weather Forecast",
    "desc" : "A weather forecasting web app that provides up-to-date weather information for a given location. Users can enter a location, and the app will provide information such as the temperature, humidity, wind speed, and precipitation for the next few days. By providing accurate and reliable weather information, the app helps users make informed decisions and stay safe in changing weather conditions.",
    "techStack" : ["React","Bootstrap","openWeatherMap API"],
    "link" : "https://kishan-kr.github.io/weather-forecast/"
  },
  {
    "title" :"Mellow",
    "desc" : "A music player that has some limited royalty free musics used for development purpose. It has responsive and interactive interface which you'd love.",
    "techStack" : ["HTML","CSS","JavaScript"],
    "link" : "https://kishan-kr.github.io/mellow/"
  },
  {
    "title" :"Type Rush",
    "desc" : "A typing test website that allows users to test their typing speed and accuracy. The website typically provides a simple and user-friendly interface where users can start a typing test and receive instant feedback on their performance. The test may consist of a random selection of words or phrases, and users are timed as they type. At the end of the test, the it provides the user with their typing speed, accuracy, and character speed. It also features different test durations.",
    "techStack" : ["HTML","CSS","JavaScript"],
    "link" : "https://kishan-kr.github.io/Type-rush/"
  },
  {
    "title" :"Calculator",
    "desc" : "A web app that allows users to perform mathematical calculations online. The app provides a simple and user-friendly interface with buttons for numbers, operators, and functions such as percentage and clear screen. Users can enter numbers and operators using the app's buttons, and the app will display the result of the calculation.",
    "techStack" : ["HTML","CSS","JavaScript"],
    "link" : "https://kishan-kr.github.io/calculator/"
  },
  {
    "title" :"Text Ease",
    "desc" : "A text utility web app that provides various tools to manipulate and format text online. Users can enter text and apply various formatting and manipulation functions. Some features include text case conversion, trimming white spaces, etc.",
    "techStack" : ["HTML","CSS","JavaScript"],
    "link" : "https://kishan-kr.github.io/text-ease/"
  },
]

export default allProjects